import React from 'react';
import { motion } from 'framer-motion';
import { Video, Plane, Globe, MousePointerClick, Instagram } from 'lucide-react';

const SERVICES = [
  { id: 'filmagem', icon: Video, title: 'Filmagem na sua empresa', what: 'Vídeos profissionais do seu negócio, equipe e produtos.', gets: 'Vídeos editados, prontos para Instagram, WhatsApp e anúncios.' },
  { id: 'aerea', icon: Plane, title: 'Filmagem aérea com drone', what: 'Imagens do alto que mostram o tamanho e a beleza do seu espaço.', gets: 'Vídeos e fotos aéreas para imóveis, obras, eventos e empresas.' },
  { id: 'sites', icon: Globe, title: 'Site profissional', what: 'Seu endereço na internet para o cliente te achar no Google.', gets: 'Site pronto, rápido no celular e com botão direto pro seu WhatsApp.' },
  { id: 'landing', icon: MousePointerClick, title: 'Landing page', what: 'Uma página só, feita para vender um produto ou serviço.', gets: 'Página pronta para anúncios, que transforma visita em contato.' },
  { id: 'instagram', icon: Instagram, title: 'Gestão do Instagram', what: 'A gente cuida do seu perfil para você focar no seu negócio.', gets: 'Posts, vídeos e legendas no ar, com constância e cara profissional.' },
];

const Row = ({ s, i }) => (
  <motion.li
    initial={{ opacity: 0, y: 24 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: '-60px' }}
    transition={{ duration: 0.55, delay: i * 0.06 }}
    className="group grid grid-cols-1 lg:grid-cols-[120px_minmax(0,1.1fr)_minmax(0,1fr)_minmax(0,1fr)] gap-x-5 gap-y-2 py-7 sm:py-9 border-t border-white/10 transition-colors duration-300 hover:bg-white/[0.025]"
    data-testid={`service-${s.id}`}
  >
    <span className="sh-mono text-xs text-[var(--sh-teal)] lg:pt-2">Cena {String(i + 1).padStart(2, '0')}</span>
    <h3 className="sh-display text-4xl sm:text-5xl flex items-center gap-3">
      <s.icon className="w-7 h-7 text-[var(--sh-teal)] shrink-0 transition-transform duration-300 group-hover:-rotate-6" />{s.title}
    </h3>
    <p className="text-[#F2F2EE]/80 text-base lg:pt-2"><span className="sh-mono text-[11px] text-[#F2F2EE]/65 block mb-1">O que é</span>{s.what}</p>
    <p className="text-[#F2F2EE] text-base font-medium lg:pt-2"><span className="sh-mono text-[11px] text-[#F2F2EE]/65 block mb-1">Você recebe</span>{s.gets}</p>
  </motion.li>
);

export const ShortServices = () => (
  <section className="px-6 sm:px-10 lg:px-16 py-24 sm:py-32" data-testid="short-services">
    <p className="sh-mono text-xs sm:text-sm text-[var(--sh-teal)] mb-4">// O que a gente faz</p>
    <h2 className="sh-display text-6xl sm:text-7xl lg:text-8xl max-w-4xl">
      Você não precisa entender. <span className="text-[var(--sh-teal)]">A gente resolve.</span>
    </h2>
    <p className="mt-6 text-base sm:text-lg text-[#F2F2EE]/70 max-w-xl">Escolha o que sua empresa precisa. Sem termos difíceis, sem enrolação.</p>
    <ul className="mt-14 border-b border-white/10">
      {SERVICES.map((s, i) => <Row key={s.id} s={s} i={i} />)}
    </ul>
  </section>
);
